import { motion } from 'framer-motion';

const line = {
  hidden: { y: '110%' },
  visible: (i) => ({
    y: '0%',
    transition: { duration: 0.9, delay: 0.25 + i * 0.14, ease: [0.22, 1, 0.36, 1] },
  }),
};

const fade = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: 0.7 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-[#f9f2e0] pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
    >
      {/* Rayon doré ensoleillé pour une ambiance lumineuse */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_10%,rgba(212,169,74,0.35),transparent_60%)]"
      />
      <div className="relative max-w-[1100px] mx-auto px-6 md:px-8 text-center">
        <motion.p
          variants={fade}
          custom={0}
          initial="hidden"
          animate="visible"
          className="text-xs uppercase tracking-[0.3em] text-[#a1802f] mb-8"
        >
          Académie Conseils &amp; Réussites · Accompagnement professionnel
        </motion.p>

        <h1 className="font-serif font-light text-[#1c1811] text-4xl sm:text-5xl md:text-6xl lg:text-[4.5rem] leading-[1.04] tracking-tight max-w-4xl mx-auto">
          <span className="reveal-mask">
            <motion.span className="block" variants={line} custom={0} initial="hidden" animate="visible">
              Redonner <span className="italic text-[#a1802f]">du sens</span> à
            </motion.span>
          </span>
          <span className="reveal-mask">
            <motion.span className="block" variants={line} custom={1} initial="hidden" animate="visible">
              votre vie professionnelle
            </motion.span>
          </span>
          <span className="reveal-mask">
            <motion.span className="block" variants={line} custom={2} initial="hidden" animate="visible">
              grâce à une méthode en <span className="italic text-[#a1802f]">cinq étapes</span>.
            </motion.span>
          </span>
        </h1>

        <motion.p
          variants={fade}
          custom={1}
          initial="hidden"
          animate="visible"
          className="mt-8 text-[#1c1811]/70 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
        >
          Pour les cadres qui ont réussi mais qui ont perdu le fil. Retrouvez
          clarté, énergie et alignement — sans tout quitter.
        </motion.p>

        <motion.div
          variants={fade}
          custom={2}
          initial="hidden"
          animate="visible"
          className="mt-10 flex items-center justify-center"
        >
          <a
            href="https://calendly.com/contact-conseils-et-reussites-academie/entretien-prive-clarte" target="_blank" rel="noopener noreferrer"
            data-testid="hero-cta"
            className="group inline-flex items-center gap-3 bg-[#d4a94a] text-[#1c1811] px-9 py-4 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#b3892f] transition-colors duration-300"
          >
            Réserver votre entretien
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              &rarr;
            </span>
          </a>
        </motion.div>
      </div>

      {/* VSL vide */}
      <motion.div
        variants={fade}
        custom={3}
        initial="hidden"
        animate="visible"
        className="relative max-w-[960px] mx-auto px-6 md:px-8 mt-16 md:mt-20"
      >
        <div
          data-testid="vsl-video"
          className="relative w-full aspect-video overflow-hidden bg-[#f2e8ce] border border-[#1c1811]/25 shadow-[0_30px_80px_-40px_rgba(212,169,74,0.35)]"
        >
          <iframe
            title="Présentation Académie Conseils & Réussites"
            src="https://fast.wistia.net/embed/iframe/6jz3eqme0v"
            allow="autoplay; fullscreen"
            allowFullScreen
            frameBorder="0"
            scrolling="no"
            className="absolute inset-0 w-full h-full"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12 flex flex-col items-center gap-4"
        >
          <a
            href="https://calendly.com/contact-conseils-et-reussites-academie/entretien-prive-clarte" target="_blank" rel="noopener noreferrer"
            data-testid="hero-cta-vsl"
            className="group inline-flex items-center gap-3 bg-[#d4a94a] text-[#1c1811] px-9 py-4 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#b3892f] transition-colors duration-300"
          >
            Réserver votre entretien
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              &rarr;
            </span>
          </a>
          <span className="text-xs uppercase tracking-[0.15em] text-[#1c1811]/45">
            45 min · offert · sans engagement
          </span>
        </motion.div>
      </motion.div>
    </section>
  );
}
